import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { ref, get, database } from "../../firebase-config";
import { getUserFromLocalStorage } from "../../shared/localStorage";
import useAuth from "../hooks/UseAuth";
import Header from "../components/Header";
import HomeCardItem from "../components/HomeCardItem";
import ModalInstruksi from "../components/ModalInstruksi";
import ElipseHome1 from "../../assets/elipseHome1.png";
import ElipseHome2 from "../../assets/elipseHome2.png";
import ElipseHome3 from "../../assets/elipseHome3.png";
import DayFlowChill from "../../assets/Dayflow-Chill.svg";
import DayFlowBestFriend from "../../assets/Dayflow-Best-Friends.svg";
import DayFlowBuyOnline from "../../assets/Dayflow-Buy-Online.svg";
import "../styles/home.css";

function Home() {
  // Set DEBUG ke true untuk menampilkan tombol "Lihat Hasil" (development mode)
  // Set DEBUG ke false untuk menampilkan pesan "sedang diproses" (production mode)
  const DEBUG = false;

  const { user } = useAuth();
  const [psikotesId, setPsikotesId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [testStatus, setTestStatus] = useState(user.status_tes);
  const navigate = useNavigate();

  const handleIkutiTestClick = () => {
    setShowModal(true);
  };

  const handleLihatHasilClick = (resultId) => {
    navigate(`/psikotesResult/${psikotesId}/${user.uid}/${resultId}`);
  };

  useEffect(() => {
    const fetchPsikotesId = async () => {
      try {
        const psikotesIdRef = ref(database, "psikotest/psikotes_id_1");
        const snapshot = await get(psikotesIdRef);
        if (snapshot.exists()) {
          setPsikotesId(snapshot.key);
        } else {
          console.error("No psikotes_id found");
        }
      } catch (error) {
        console.error("Error fetching psikotes_id:", error);
      }
    };

    fetchPsikotesId();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const { storedUser } = getUserFromLocalStorage();
      if (storedUser && storedUser.status_tes) {
        setTestStatus(storedUser.status_tes);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const { storedUser } = getUserFromLocalStorage();
    if (storedUser && storedUser.status_tes) {
      setTestStatus(storedUser.status_tes);
    }
  }, []);

  return (
    <Container fluid className="home-container">
      <Header />
      <Image src={ElipseHome1} className="elipse-home1" />
      <Image src={ElipseHome2} className="elipse-home2" />
      <Image src={ElipseHome3} className="elipse-home3" />
      <Row className="d-flex justify-content-center align-items-center text-center gap-2">
        <Col md={7} xs={10} className="heading-home-txt">
          {testStatus === "Completed Test" ? (
            <h1>
              Terima Kasih, {user.name}! Kamu Sudah Berhasil Menyelesaikan Tes
              Kepribadian Kami! 🎉
            </h1>
          ) : (
            <h1>
              Halo {user.name}, Kenali Kepribadianmu Lebih Dalam: Ikuti Tes Kami
              dan Temukan Diri Sejatimu
            </h1>
          )}
        </Col>
        <Col md={8} xs={10} className="home-txt">
          {testStatus === "Completed Test" ? (
            DEBUG ? (
              // Pesan untuk DEBUG mode (code lama)
              <p>
                "Yeay! Kamu Sudah Menyelesaikan Tes Kepribadian. Sekarang, Mari
                Rayakan Dirimu yang Unik dan Hebat! Lihat hasil tesmu dan temukan
                potensi luar biasa yang kamu miliki dengan klik tombol 'Lihat
                Hasil'."
              </p>
            ) : (
              // Pesan untuk production mode (hasil sedang diproses)
              <div>
                <p>
                  Hasil tes kepribadianmu sudah kami terima dengan baik.<br></br>Kami sedang memproses hasilnya dan akan mengirimkannya ke emailmu dalam waktu dekat.
                </p>
                <p style={{ fontSize: '1.25rem', fontWeight: '500' }}>
                  Terima kasih atas partisipasimu! 😊
                </p>
              </div>
            )
          ) : (
            <p>
              "Ungkap Potensi & Kekuatanmu: Ikuti Tes Kepribadian Ahli Kami Hari
              Ini!"
            </p>
          )}
        </Col>
      </Row>
      {DEBUG && (
        <Row className="justify-content-center align-items-center mt-2 mb-5" id="home-card-row">
          <Col
            md={6}
            xs={12}
            className="mb-3 mb-md-0 d-flex justify-content-md-end justify-content-center"
          >
            <HomeCardItem
              cardImageHome={DayFlowBestFriend}
              cardTextHome={"Kenali Dirimu"}
            />
          </Col>
          <Col
            md={6}
            xs={12}
            className="mb-3 mb-md-0 d-flex justify-content-md-start justify-content-center"
          >
            <HomeCardItem
              cardImageHome={DayFlowChill}
              cardTextHome={"Temukan Potensi Dirimu"}
            />
          </Col>
          <Col md={6} xs={12} className="d-flex mt-md-4 justify-content-center">
            <HomeCardItem
              cardImageHome={DayFlowBuyOnline}
              cardTextHome={"Kembangkan Dirimu"}
            />
          </Col>
        </Row>
      )}
      <Row className="text-center my-5">
        <Col md={12}>
          {testStatus === "Completed Test" ? (
            DEBUG ? (
              // Tombol untuk DEBUG mode (code lama)
              <Button
                className="btn-lihat-hasil"
                onClick={() => handleLihatHasilClick("result_id_1")}
              >
                Lihat Hasil
              </Button>
            ) : null // Production mode: tombol disembunyikan
          ) : (
            <Button
              className="btn-ikuti-psikotes"
              onClick={handleIkutiTestClick}
            >
              Ikuti Test
            </Button>
          )}
        </Col>
      </Row>
      <ModalInstruksi
        show={showModal}
        onHide={() => setShowModal(false)}
        showMulaiButton={true}
        psikotesId={psikotesId}
      />
    </Container>
  );
}

export default Home;
